import httpService from "@/utils/httpService";

const baseUrl = "api/TagGroups";

export default {
    get(params, config = {}) {
        return httpService.get({
            url: baseUrl,
            params,
            ...config,
        });
    },
    getCounts(params) {
        return httpService.get({
            url: `${baseUrl}/counts`,
            params,
        });
    },
    typeHead(params, signal = null) {
        return httpService.get({
            url: `${baseUrl}/TypeHead`,
            params,
            signal,
        });
    },
    add(data) {
        return httpService.post({
            url: baseUrl,
            data,
        });
    },
    update(data) {
        return httpService.put({
            url: baseUrl,
            data,
        });
    },
    delete(id) {
        return httpService.delete({
            url: `${baseUrl}/${id}`,
        });
    },
    getDeletionImpact(ids, assetId) {
        return httpService.post({
            url: `${baseUrl}/deletionImpact`,
            data: { ids, assetId },
        });
    },
}